/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

import { createGetPromptNameAvailabilityService } from '../../../../common/prompt/createPromptV2Services';
import * as constants from '../../constants/ServiceConstants';
import { PROMPT_MANAGEMENT_LANG_KEYS } from '../../constants/StudioTextConstants';

export default createGetPromptNameAvailabilityService({
  eventName: constants.GET_PROMPT_NAME_AVAILABILITY,
  statusKey: 'getPromptNameAvailabilityStatus',
  storeName: 'studioPromptModel',
  errorLangKey: PROMPT_MANAGEMENT_LANG_KEYS.ERROR_NAME_AVAILABILITY,
  errorEvent: constants.GET_PROMPT_NAME_AVAILABILITY_ERROR
});
